export const labelSizesThemes = {
    sm: {
        labelTheme: 'body3',
        extraTheme: 'body4',
        labelWeight: 'regular',
        iconSize: 16,
        extraGap: 'xs',
        marginBlockEnd: 'xs',
    },
    md: {
        labelTheme: 'body2',
        extraTheme: 'body3',
        labelWeight: 'regular',
        iconSize: 20,
        extraGap: 'xs',
        marginBlockEnd: 'sm',
    },
    lg: {
        labelTheme: 'body1',
        extraTheme: 'body2',
        labelWeight: 'medium',
        iconSize: 24,
        extraGap: 'sm',
        marginBlockEnd: 'sm',
    },
    xl: {
        labelTheme: 'subtitle1',
        extraTheme: 'body2',
        labelWeight: 'semi-bold',
        iconSize: 28,
        extraGap: 'sm',
        marginBlockEnd: 'sm',
    },
};
